//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import PwrError from '../misc/PwrError.vue';
import VendorEmailInput from '../form/VendorEmailInput';
import VendorPasswordInput from '../form/VendorPasswordInput';

export default {
  name: 'EmailPasswordVendorLogin',
  components: {
    VendorPasswordInput,
    VendorEmailInput,
    PwrError,
  },
  props: {
    error: {
      default: null,
    },
    vendor: {
      type: String,
      required: true,
    },
  },
  data: function data() {
    return {
      credentials: {
        email: null,
        password: null,
      },
    };
  },
  methods: {
    propagate() {
      this.$emit('input', this.credentials);
    },
  },
};
